// Chakra
import { Box, Divider, Flex, Text, useColorModeValue } from '@chakra-ui/react';
import { useHistory } from 'react-router-dom';

// Assets
import { parseDateTime } from 'services/Utils';

// Components
import Card from 'components/Card/Card';
import CardBody from 'components/Card/CardBody';
import { useCallback } from 'react';

const GiveawaysRow = ({ object }) => {
  const history = useHistory();
  const borderColor = useColorModeValue('blue.50', 'rgba(255, 255, 255, 0.10)');

  const openGiveaway = useCallback(
    (giveaway) => {
      const hash = window.location.hash;
      console.log(hash);

      if (!giveaway) {
        return;
      }
      if (hash.includes('daily-giveaways')) {
        history.push(`/daily-giveaways/${giveaway.id}`);
      } else {
        history.push(`/giveaways/${giveaway.id}`);
      }
    },
    [history]
  );

  return (
    <Card key={object.id} padding="24px" onClick={() => openGiveaway(object)}>
      <CardBody>
        <Box w="100%">
          <Flex justifyContent="space-between" w="100%" mb="10px">
            <Flex gap="4px">
              <Text variant="text-md">Created:</Text>
              <Text variant="text-md" fontWeight="500" color="white">
                {parseDateTime(object.createdAt)}
              </Text>
            </Flex>

            <Text
              variant="text-md"
              mt="-3px"
              minW="110px"
              className={
                object.status === 'active'
                  ? 'tag-green'
                  : object.status === 'inactive'
                  ? 'tag-orange'
                  : 'tag-red'
              }
            >
              {object.status}
            </Text>
          </Flex>

          <Text
            variant="title"
            transition="0.2s all"
            lineHeight="34px"
            fontWeight="700"
            fontSize="28px"
            whiteSpace="nowrap"
            overflow="hidden"
            textOverflow="ellipsis"
          >
            {object.title}
          </Text>
          <Text variant="text" mt="2px" mb="-4px">
            {object.description.length > 60
              ? `${object.description.slice(0, 60)}...`
              : object.description}
          </Text>

          <Divider
            opacity="1"
            my="16px"
            borderColor={borderColor}
            borderTopWidth="1px"
            borderBottomWidth="0"
          />

          <Flex gap="4px" mb="16px">
            <Text variant="text-md">End date:</Text>
            <Text variant="text-md" fontWeight="500" color="white">
              {parseDateTime(object.endDate)}
            </Text>
          </Flex>
        </Box>
      </CardBody>
    </Card>
  );
};

export default GiveawaysRow;
